var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1178({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{stroke-linecap:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.82,1S5.48.69,3.06,5.38c-.2.39-1.64,3.19-.33,5.31,1.55,2.5,5.82,2.38,7.73,0,1.43-1.88,1.72-4.65,2.16-6.77A6.35,6.35,0,0,1,13.82,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.14,2.87S4.63,8.29,3.27,15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1178);
export default __webpack_public_path__ + "static/media/Symbolpack_1_178.951f153fb7841c213fa03c2edaa925ee.svg";
export { ForwardRef as ReactComponent };